import { useBookingStore } from "@stores/useBookingStore";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useDAP } from "../dap.hook";
import PassportForm from "./PassportForm";
import { routes } from "@routes";
import { Button, Icon } from "@thetreep/ui";
import { useForm } from "react-hook-form";
import { Passport, PassportSchema } from "@gen/travel/v1/common_pb";
import { useEffect } from "react";
import { create } from "@bufbuild/protobuf";

export function Passports() {
  const { outwardOffer, outwardResults, addPassport } = useBookingStore();

  const { t } = useTranslation();
  const { search } = useLocation();
  const navigate = useNavigate();
  const { dap } = useDAP();

  const { control, formState, reset, getValues, trigger, watch, setValue } =
    useForm<{
      passports: Passport[];
    }>({
      mode: "onChange",
    });

  function handleConfirm() {
    outwardResults?.passengers?.forEach((p, i) => {
      addPassport(p.id, getValues(`passports.${i}`));
    });
    navigate(routes.RECAP + search);
  }

  useEffect(() => {
    if (!outwardResults) return;
    const passports: Passport[] = [];
    for (let i = 0; i < outwardResults.passengers.length + 1; i++) {
      passports.push(create(PassportSchema, {}));
    }
    reset({ passports });
  }, [outwardResults, reset]);

  if (!outwardResults) return null;

  return (
    <div className="flex flex-col gap-8">
      <h1
        data-testid="journey-header"
        className="text-[24px] md:text-[32px] font-jakarta font-bold mb-6"
      >
        {!outwardOffer
          ? `${t("search.outward")}: ${dap.origin?.name} → ${
              dap.destination?.name
            }`
          : `${t("search.return")}: ${dap.destination?.name} → ${
              dap.origin?.name
            }`}
      </h1>
      {outwardResults.passengers?.map((p, i) => (
        <div key={i}>
          <PassportForm
            index={i}
            control={control}
            trigger={trigger}
            watch={watch}
            passenger={p}
            setValue={setValue}
          />
        </div>
      ))}
      <div className="self-end">
        <Button
          kind="primary"
          disabled={!formState.isValid}
          onClick={() => handleConfirm()}
          endEnhancer={<Icon color="white" src="arrow_right_line" />}
        >
          {t("options.next")}
        </Button>
      </div>
    </div>
  );
}
